export class Scan{

  _id : string
  scannerId: string;
  templateId: string;
  org: string
  share: string;
}
